const getBabyBedPrice = (countTotalDays) => {
  return countTotalDays * 10;
};

export default getBabyBedPrice;
